export function getPortabilityParams() {
  const params = new URLSearchParams(window.location.search);

  return {
    hideInstructions: params.get("hideInstructions")
      ? params.get("hideInstructions") === "true"
      : false,
    hideAbout: params.get("hideAbout")
      ? params.get("hideAbout") === "true"
      : false,
    hideImage: params.get("hideImage")
      ? params.get("hideImage") === "true"
      : false,
    size: params.get("size") ?? "default",
  };
}
